import { gql, useLazyQuery } from '@apollo/client'
import useAuth from '@nobia/zeus-components/lib/auth/useAuth'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'

import { CustomerFragment } from '../../graphql/CustomerFragments'
import { StaffMemberFragment } from '../../graphql/StaffMemberFragment'
import { StoreFragment } from '../../graphql/StoreFragments'
import { useAccountContext } from '../AccountContext'

const UserContext = React.createContext({ customer: {} })

export const useUser = () => React.useContext(UserContext)

const UserQuery = gql`
  ${CustomerFragment}
  ${StoreFragment}
  ${StaffMemberFragment}
  query User($storeId: Int) {
    me {
      id
      customer {
        ...Customer
        messagingEnabled(storeId: $storeId)
        unreadStoreMessages(storeId: $storeId)
        store {
          ...Store
        }
        staff {
          ...StaffMember
        }
      }
    }
  }
`

export const UserProvider = ({ children }) => {
  const { store } = useAccountContext()
  const [loadUser, { data, loading, refetch }] = useLazyQuery(UserQuery)
  const { status } = useAuth()
  const [state, setState] = useState({})

  useEffect(() => {
    if (status === 'authenticated') {
      loadUser({
        variables: { storeId: store?.id },
      })
    } else {
      setState({})
    }
  }, [loadUser, status, store?.id])

  useEffect(() => {
    if (!data?.me?.customer) {
      return
    }

    setState({
      ...data.me.customer,
      store: data.me.customer.store || {},
      staff: data.me.customer.staff || {},
    })
  }, [data])

  const value = useMemo(
    () => ({
      customer: {
        ...state,
      },
      reload: refetch,
      loading,
    }),
    [state, refetch, loading]
  )
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
